module.exports = __webpack_public_path__ + "img/avatarSelected.2f4a5996.png";